import { EntitySelector } from "@/components/EntitySelector/EntitySelector";
import { IntegrationConnection } from "@cohesive/api-client";
import { Entity } from "@cohesive/ui-components";
import React from "react";

interface ConnectionsMenuProps {
  activeConnection: IntegrationConnection;
  setConnectionsMenuOpen: (open: boolean) => void;
  handleRecordSelect: (entity: Entity) => void;
}

export const ConnectionsMenu: React.FC<ConnectionsMenuProps> = ({
  activeConnection,
  setConnectionsMenuOpen,
  handleRecordSelect,
}) => {
  const handleBack = () => {
    // Close the connections menu entirely and return to the main add menu
    setConnectionsMenuOpen(false);
  };

  return (
    <div className="h-[520px] flex flex-col">
      <EntitySelector
        connection={activeConnection}
        onClose={() => setConnectionsMenuOpen(false)}
        onSelect={handleRecordSelect}
        onBack={handleBack}
        className="flex-1"
      />
    </div>
  );
};
